import * as React from "react";
import {Grid} from "@mui/material";
import {FormattedMessage, MessageDescriptor} from "react-intl";
import {labelStyle, valueStyle} from "../../styles";

type Props = {
    label: MessageDescriptor;
    value: string | number | boolean;
};

const EnabledOrDisabledItem = ({label, value}: Props) => {
    function enabledOrDisabled(_value: string | number | boolean): React.ReactNode {
        return _value ? (
            <FormattedMessage id="enabled" defaultMessage="Enabled" />
        ) : (
            <FormattedMessage id="disabled" defaultMessage="Disabled" />
        );
    }

    return (
        <Grid container>
            <Grid style={labelStyle} size="grow">
                <FormattedMessage {...label} />:
            </Grid>
            <Grid style={valueStyle} size="grow">
                {enabledOrDisabled(value)}
            </Grid>
        </Grid>
    );
};

export default EnabledOrDisabledItem;
